/* eslint-disable */
// src/tables/visitStrategies/RentStrategy.js

import React from "react";
import BaseStrategy from "./BaseStrategy";
import { getRentPrice, getRentFrequency } from "utils/rent";
import { moneyFmtDynamic } from "utils/formatters";
import {
  RENTED_MACHINE_DATA_WIDTH,
  centeredDataBlockStyle,
  fullWidthDataRowStyle,
} from "components/visit/individualEditorSizing";

export default class RentStrategy extends BaseStrategy {
  buildCells(m) {
    const key = this.computeKey(m);
    const isCollected = this.isWasCollected(m, key);
    const rentPrice = getRentPrice(m);
    const rentFreq  = getRentFrequency(m);

    const machineCell = this.MachineCell({ m, hasRent: true, formulaText: null });
    const noteCell = this.NoteCell({ keyId: key, m });

    if (!isCollected && this.isRead) {
      return { Machine: machineCell, Note: noteCell };
    }

    // In (edit/read) — mismo layout que el original
    let inCell = null;
    if (this.isRead) {
      inCell = (
        <div style={this.individualEditorLayout ? centeredDataBlockStyle(RENTED_MACHINE_DATA_WIDTH) : undefined}>
          <div>
            Precio alquiler:{" "}
            <strong>
              {rentPrice != null ? moneyFmtDynamic.format(rentPrice) : "—"}
            </strong>
          </div>
          <div>
            Frecuencia: <em>{rentFreq || "-"}</em>
          </div>
        </div>
      );
    } else {
      inCell = (
        <div style={this.individualEditorLayout ? centeredDataBlockStyle(RENTED_MACHINE_DATA_WIDTH) : undefined}>
          <div style={this.individualEditorLayout ? fullWidthDataRowStyle(this.rowLine) : this.rowLine}>
            <span>Precio alquiler:</span>
            <span style={{ fontWeight: 700 }}>
              {rentPrice != null ? moneyFmtDynamic.format(rentPrice) : "—"}
            </span>
          </div>
          <div
            style={{
              ...(this.individualEditorLayout
                ? fullWidthDataRowStyle(this.rowLine)
                : this.rowLine),
              marginTop: 4,
            }}
          >
            <span>Frecuencia:</span>
            <span style={{ fontStyle: "italic", color: "#555" }}>
              {rentFreq || "No especificada"}
            </span>
          </div>
        </div>
      );
    }

    return { Machine: machineCell, In: inCell, Note: noteCell };
  }
}


